import { useMemo as C, useRef as L, useState as g, useEffect as v } from "react";
import { useChatbotContext as x } from "./useChatbotContext.js";
import { AI_SUGGESTION_ID as G } from "../constants.js";
function h(u) {
  var E;
  const {
    isEditing: d,
    isLoading: f,
    chatbot: s,
    suggest: o,
    sessionId: t,
    messages: a
  } = x(), i = a[a.length - 1], e = C(() => (i == null ? void 0 : i.id) ?? "", [i]), c = ((E = s == null ? void 0 : s.suggestions) == null ? void 0 : E.some((r) => r.id === G)) ?? !1, l = L(void 0), [n, m] = g(!1), [I, S] = g(!1), [p, A] = g([]);
  return v(() => {
    u && !n && !I && !d && o !== void 0 && (s != null && s.id) && c && !f && t && e && e !== l.current && (l.current = e, m(!0), o(s.id, t, e).then(A).catch((r) => {
      console.error("Error fetching AI suggestions", r), S(!0);
    }).finally(() => m(!1)));
  }, [
    u,
    n,
    I,
    d,
    o,
    s == null ? void 0 : s.id,
    c,
    f,
    t,
    e
  ]), {
    isLoading: n,
    aiSuggestions: p
  };
}
export {
  h as useAiSuggestions
};
